<template>
  <section class="banda_logos py-3 py-lg-5">
    <div class="container-fluid">
      <div
        class="row d-flex justify-content-center align-items-center flex-wrap"
      >
        <a
          v-for="logo in logos"
          :key="logo.idGaleriaFoto"
          :href="logo.link"
          target="_blank"
          class="logo_patrocinadores"
        >
          <img :src="logo.imagen" :title="logo.nombre" :alt="logo.nombre" />
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
/* eslint-disable */
import { onMounted, ref, watch } from "vue";
import { get_banda_logos } from "@/lib/peticiones_api";

const logos = ref({});

const props = defineProps({
  logosJornada: {
    type: Object,
  },
});
const obtener_banda_logos = async () => {
  let respuesta = await get_banda_logos();

  if (respuesta == null) {
    console.log("error en la peticion");
    return;
  }

  if (respuesta.result == "success") {
    let { data } = respuesta;
    logos.value = data;
  } else {
    console.log("error en la peticion", respuesta);
  }
};

onMounted(() => {
  if (props.logosJornada) {
    logos.value = props.logosJornada;
  } else {
    obtener_banda_logos();
  }
});

watch(
  () => props.logosJornada,
  (newVal) => {
    if (Array.isArray(newVal) && newVal.length > 0) {
      logos.value = newVal;
    } else {
      obtener_banda_logos();
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.banda_logos .logo_patrocinadores {
  display: inline-flex !important;
  width: auto;
  margin: 10px 0px;
}
.logo_patrocinadores img {
  object-fit: contain;
  max-height: 70px;
  max-width: 200px;
}

@media (width <= 575.98px) {
  .logo_patrocinadores img {
    object-fit: contain;
    max-height: 40px;
    max-width: 100px;
  }
}

/* Small devices (landscape phones, 576px and up)*/
@media (576px <= width <= 767.98px) {
  .logo_patrocinadores img {
    object-fit: contain;
    max-height: 40px;
    max-width: 150px;
  }
}
</style>
